import { makeAutoObservable } from 'mobx';

import { stringToColor } from '@cutwise/utils';

import { store } from '@/dmdrive/store';
import { Roles } from '@/dmdrive/topic/constants/roles';

export interface TopicUserModel {
  isOnline: boolean;
  id: number;
  urn: Nullable<string>;
  username: string;
  email: string;
  roles: Roles[];
  requestMaster?: boolean;
}

export class TopicUser implements TopicUserModel {
  isOnline!: boolean;
  id!: number;
  urn!: Nullable<string>;
  username!: string;
  email!: string;
  roles!: Roles[];
  requestMaster?: boolean;

  constructor(model: TopicUserModel) {
    makeAutoObservable(this);

    Object.assign(this, model);
  }

  get isMe() {
    return Boolean(store.appStore.user?.isMe(this.id));
  }

  get isMaster() {
    return this.hasRole(Roles.Master);
  }

  get isOwner() {
    return this.hasRole(Roles.Owner);
  }

  get isSpectator() {
    return this.hasRole(Roles.Spectator);
  }

  get color() {
    return stringToColor(this.username);
  }

  setOnline(state: boolean) {
    this.isOnline = state;
  }

  hasRole(role: Roles) {
    return Boolean(this.roles?.includes(role));
  }
}
